import React from "react";
import { Modal } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import iconClose from "../../../assets/images/icon-close-menu.svg";
import { LINK } from "../../Navigation/NavigationBar";
import { Link } from "react-router-dom";
import { iconNavigation } from "../../../constants/iconNavigation";
import { useTheme } from "../../../hook/useThemes";
import useScreen, { SCREEN_LIST } from "../../../hook/useScreen";
import useDeviceDetect from "../../../hook/useDeviceDetect";
import { activeEventFathom } from "../../../utils/utils";

type PropsContentHowToPlay = {
  open: boolean;
  onClose: () => void;
};

export default function NavigationMobile({
  onClose,
  open,
}: PropsContentHowToPlay) {
  const classes = useStyles();
  const { operatorId, lang } = useTheme();

  const heightScreen = useScreen();
  const { isMobile } = useDeviceDetect();
  const isMinHeight = heightScreen <= SCREEN_LIST.screenHeight2 && isMobile;

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
    >
      <div
        className={`${classes["wrapper-content-modal"]}`}
        onClick={(e) => e?.stopPropagation()}
      >
        <div className={classes["content-modal"]}>
          {LINK.map((item) => {
            return (
              <Link
                to={`${item.to}${window.location.search}`}
                key={item.title}
                onClick={() => {
                  activeEventFathom(item.key)
                  if (item.to === "/") {
                    onClose();
                  }
                }}
              >
                <div
                  className={`${classes[`item-navigation`]} ${
                    classes["is-select"]
                  }`}
                >
                  <div className="wrap-icon">
                    {iconNavigation?.[operatorId || 1]?.[item?.to]}
                  </div>
                  <p className={classes["title-navigation"]}>
                    {lang?.[`${item.title}`.toLowerCase()] || item.title}
                  </p>
                </div>
              </Link>
            );
          })}
          
        </div>
        <div className={`${classes["wrapper-button-close"]} ${
            isMinHeight && classes["wrapper-button-close-min"]
          }`}>
            <button className={classes["button-close"]} onClick={onClose}>
              <img
                src={iconClose}
                alt="icon_close"
                className={classes["icon-close"]}
              />
              {lang?.close || "Close"}
            </button>
          </div>
      </div>
    </Modal>
  );
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",

    "& .MuiBackdrop-root": {
      top: "68px !important",
      bottom: "0px !important",
    },
    "& .MuiModal-backdrop": {
      background: "#141C29 !important",
    },
  },

  "wrapper-content-modal": {
    position: "fixed",
    width: "215px",
    display: "flex",
    flexDirection: "column",
    // position: "relative",
    zIndex: 2,

    "@media (max-width: 1229px)": {
      // height: "calc(100% - 68px)",
      marginTop: "0px",
      top: "50%",
      transform: "translateY(-50%)",
    },
  },

  "content-modal": {
    display: "flex",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    // gap: "8px",
    color: "#fff",

    "& a": {
      color: "#141C29 !important",
    },
  },

  "item-navigation": {
    display: "flex",
    alignItems: "center",
    padding: "20px 0px 20px",
    color: "#7c7b73",
    position: "relative",

    "& svg": {
      marginRight: "10px",
    },

    "& .wrap-icon": {
      minWidth: "32px",
    },

    "&:before": {
      content: "' '",
      position: "absolute",
      left: "0px",
      bottom: "0px",
      height: "1px",
      width: "100%",
      background: "#fff",
    },
  },

  "is-select": {
    color: " #f3f4f3",

    "& svg": {
      "& path": {
        fill: "#f3f4f3",
      },
    },
  },

  "title-navigation": {
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "24px",
  },

  "wrapper-button-close": {
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    bottom: "-100px",
    width: "100%",
  },

  "wrapper-button-close-min": {
    bottom: "-50px",
  },

  "button-close": {
    display: "flex",
    alignItems: "center",
    padding: "6px",
    background: "transparent",
    border: "1px solid #525965",
    borderRadius: "6px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#ffffff1f",
    },
  },

  "icon-close": {
    marginRight: "6px",
  },
}));
